import { useEffect, useState } from "react";
import { listenToGarmentById } from "../services/garmentDetailService";

export function useGarment(garmentId) {
  const [garment, setGarment] = useState(null);
  const [garmentLoading, setGarmentLoading] = useState(true);
  const [garmentError, setGarmentError] = useState(null);

  useEffect(() => {
    setGarmentLoading(true);
    setGarmentError(null);

    const unsubscribe = listenToGarmentById(
      garmentId,
      (data) => {
        setGarment(data);
        setGarmentLoading(false);
      },
      (error) => {
        console.error("Unable to load garment:", error);
        setGarmentError(error);
        setGarmentLoading(false);
      }
    );

    return () => unsubscribe();
  }, [garmentId]);

  return {
    garment,
    garmentLoading,
    garmentError,
  };
}
